import React, { Component, Dispatch } from 'react';
import { Log } from 'ng2-logger';
import Translator from '../../../../../core/i18n';
import { Common } from '../../../../../core/common';
import { IParagraphProps } from '../../../../../models/components/add-activity-survey-questions';
import { IAction, IAppState } from '../../../../../models/action/core';
import { connect } from 'react-redux';

const T = Translator.create();
const _logger = Log.create('profile-tabpanel');
let _common: Common;

export class Paragraph extends Component<IParagraphProps, any> {
    constructor(props: any) {
        super(props);
        _common = new Common();

        this.props.deleteQuestion.bind(this);
    }

    handleDelete = () => {
        this.props.deleteQuestion(this.props.question.displayOrder, false, T.t('r_delete_survey_question_paragraph'));
    }

    onChange = (e: any) => {
        if (e && e.target) {
            const question = this.props.question;
            question.description = e.target.value;
            this.props.editQuestion(question);
        }
    }

    onEdit = () => {
        const item = document.getElementById('survey_paragraph_' + this.props.question.displayOrder);
        if (item) {
            item.focus();
        }
    }

    public render() {
        return (
            <React.Fragment>
                <div className="w-85 ">
                    <div className="survey_question_paragraph">
                    <textarea
                            name="survey_paragraph"
                            className="survey_paragraph_text"
                            id={'survey_paragraph_' + this.props.question.displayOrder}
                            cols={30}
                            rows={10}
                            placeholder={T.t('r_survey_paragraph_questions')}
                            value={this.props.question.description}
                            onChange={this.onChange}
                            style={{textAlign: 'start', paddingRight: "1.5rem"}}
                        />
                        
                    </div>
                </div>
                <div>
                    <div className="btn_container">
                        <span className="move_btn" {...this.props.dragHandleProps}>
                            <i className="material-icons">open_with</i>
                        </span>
                        <span className="delete_btn" onClick={this.handleDelete}>
                            <i className="material-icons">close</i>
                        </span>
                    </div>
                </div>
            </React.Fragment>
        );
    }
}

const mapStateToProps = (state: IAppState, ownProps: IParagraphProps): IParagraphProps => {
    if (!state) {
        return ownProps;
    }

    const newProps: IParagraphProps = Object.assign({}, ownProps, {
        coursePageActivityId: state.coursePage.coursePageActivityId,
        coursePageClassId: state.coursePage.coursePageClassId
    });

    return newProps;
};

const areStatesEqual = (next: IAppState, prev: IAppState) => {
    const ret =
        next.coursePage.coursePageActivityId === prev.coursePage.coursePageActivityId &&
        next.coursePage.coursePageClassId === prev.coursePage.coursePageClassId;
    return ret;
};

const dispatchProps = (dispatch: Dispatch<IAction>) => {
    return {
        dispatch
    };
};

const CParagraph = connect(mapStateToProps, dispatchProps, null, {
    areStatesEqual
})(Paragraph);

export default CParagraph;
